var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualRestricted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 4.5,
    fill: "#444444",
    stroke: "#444444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5355 16.5355C17.4404 15.6307 18 14.3807 18 13C18 10.2386 15.7614 8 13 8C11.6193 8 10.3693 8.55967 9.46444 9.46444M16.5355 16.5355C15.6307 17.4404 14.3807 18 13 18C10.2386 18 8 15.7614 8 13C8 11.6193 8.55967 10.3693 9.46444 9.46444M16.5355 16.5355L13 13L9.46444 9.46444",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualRestricted);
export default __webpack_public_path__ + "static/media/manualRestricted.74c7f2b6898100ef7c724f1faaaeb931.svg";
export { ForwardRef as ReactComponent };